











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db } from "@/scripts/firebase";
import { collectionName } from "@/services/collection-name";
import Chat from "./Chat.vue";

@Component({
  components: {
    Chat,
  },
})
export default class ChatForJinro extends Vue {
  @Prop() readonly jinroGameId!: string;
  get isKilled(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      const that = this.$store.state.jinroPlayerGame;
      return !!that.isKilled;
    } else {
      return false;
    }
  }
  get refChatroom(): firebase.firestore.CollectionReference {
    return db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinromessages);
  }
}
